import { setInValidUser } from "../authActions/authAction";
import {
  FAIL_REQUEST,
  MAKE_REQUEST,
  CREATE_MINUTE_RESPONSE,
  SET_FINAL_MINUTES_DATA,
  CREATE_NEW_AGENDA_RESPONSE,
  SET_FINAL_AGENDA_MINUTES_DATA,
  SET_AGENDA_DATAS,
  SET_SUCCESS,
  UPDATE_MINUTE_RESPONSE,
  PROCESS_AMENDMENT_REQUEST,
  UPDATE_AMENDMENT_REQUEST,
  EDIT_AGENDA_RESPONSE,
  DELETE_AGENDA_RESPONSE,
  SET_MOM_ACCEPT_DETAILS,
  MAKE_UPDATE_REQUEST,
} from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import * as constantMessages from "../../../constants/constatntMessages";
import {
  getAgendaWithMinutesDetails,
  getMeetingActivitiesDetails,
  getSingleMeetingDetailsForUpdate,
} from "../meetingActions/MeetingAction";
import { handleApiError } from "../../../helpers/errorResponseHelper";

export const makeRequest = (data) => {
  return {
    type: MAKE_REQUEST,
    payload: data,
  };
};
export const failRequest = (err) => {
  return {
    type: FAIL_REQUEST,
    payload: err,
  };
};

export const createMinutes = (payload, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/createMinutes`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .post(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(setSuccess(true));
          dispatch(getAgendaWithMinutesDetails(payload.meetingId, accessToken));
          dispatch(getMeetingActivitiesDetails(payload.meetingId, accessToken));
          toast.success(constantMessages.minuteCreated, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(createMinuteResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const createMinuteResponse = (data) => {
  return {
    type: CREATE_MINUTE_RESPONSE,
    payload: data,
  };
};

export const setFinalMinuteData = (data) => {
  return {
    type: SET_FINAL_MINUTES_DATA,
    payload: data,
  };
};

export const addAgendaDetails = (payload, meetingId, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/agenda/createAgendaWithMinutes`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .post(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(getAgendaWithMinutesDetails(meetingId, accessToken));
          dispatch(getMeetingActivitiesDetails(meetingId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(createAgendaResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const createAgendaResponse = (data) => {
  return {
    type: CREATE_NEW_AGENDA_RESPONSE,
    payload: data,
  };
};
export const setAgendaData = (data) => {
  return {
    type: SET_AGENDA_DATAS,
    payload: data,
  };
};
export const setFinalAgendaMinuteData = (data) => {
  return {
    type: SET_FINAL_AGENDA_MINUTES_DATA,
    payload: data,
  };
};

export const setSuccess = (data) => {
  return {
    type: SET_SUCCESS,
    payload: data,
  };
};
export const makeUpdateRequest = (value) => {
  return {
    type: MAKE_UPDATE_REQUEST,
    payload: value,
  };
};
export const rejectAcceptMinute = (payload, minuteId, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(payload.status));
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/acceptOrRejectMinutes/${minuteId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(getAgendaWithMinutesDetails(payload.meetingId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(updateMinuteResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const updateMinuteResponse = (data) => {
  return {
    type: UPDATE_MINUTE_RESPONSE,
    payload: data,
  };
};

export const processAmendmentRequest = (payload, minuteId, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(payload.status));
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/createAmendmentRequest/${minuteId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(getAgendaWithMinutesDetails(payload.meetingId, accessToken));

          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(processAmendmentRequestResponse(resData));
      })
      .catch((err) => {
        if (handleApiError(err)) return;
        
      });
  };
};

export const processAmendmentRequestResponse = (data) => {
  return {
    type: PROCESS_AMENDMENT_REQUEST,
    payload: data,
  };
};

export const updateAmendmentRequest = (payload, minuteId, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(payload.status));
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/updateAmendmentRequest/${minuteId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(getAgendaWithMinutesDetails(payload.meetingId, accessToken));
          dispatch(getMeetingActivitiesDetails(payload.meetingId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(updateAmendmentRequestResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const updateAmendmentRequestResponse = (data) => {
  return {
    type: UPDATE_AMENDMENT_REQUEST,
    payload: data,
  };
};

export const editAgenda = (payload, agendaId, accessToken, fromViewMeeting) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(null));
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/agenda/updateAgenda/${agendaId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          if (fromViewMeeting) {
            dispatch(
              getSingleMeetingDetailsForUpdate(payload.meetingId, accessToken)
            );
          } else {
            dispatch(
              getAgendaWithMinutesDetails(payload.meetingId, accessToken)
            );
            dispatch(
              getMeetingActivitiesDetails(payload.meetingId, accessToken)
            );
          }

          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(editAgendaResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const editAgendaResponse = (data) => {
  return {
    type: EDIT_AGENDA_RESPONSE,
    payload: data,
  };
};

export const deleteAgenda = (payload, agendaId, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(null));
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/agenda/deleteAgenda/${agendaId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(getAgendaWithMinutesDetails(payload.meetingId, accessToken));
          dispatch(getMeetingActivitiesDetails(payload.meetingId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(deleteAgendaResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const deleteAgendaResponse = (data) => {
  return {
    type: DELETE_AGENDA_RESPONSE,
    payload: data,
  };
};

export const deleteMinute = (meetingId, minuteId, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/deleteMinute/${minuteId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    const bodyPayload = {
      meetingId,
    };
    axios
      .put(webApiUrl, bodyPayload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(getAgendaWithMinutesDetails(meetingId, accessToken));
          dispatch(getMeetingActivitiesDetails(meetingId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(updateMinuteResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const updateMinute = (payload, minuteId, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest(payload.status));
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/updateMinute/${minuteId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(getAgendaWithMinutesDetails(payload.meetingId, accessToken));
          dispatch(getMeetingActivitiesDetails(payload.meetingId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(updateMinuteResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const acceptMOM = (meetingId, payload, accessToken) => {
  return (dispatch) => {
      if (!accessToken) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    dispatch(setSuccess(false));
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/acceptMinutes/${meetingId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          dispatch(getAgendaWithMinutesDetails(meetingId, accessToken));
          dispatch(getMeetingActivitiesDetails(meetingId, accessToken));
          dispatch(getMomAcceptDetails(meetingId, accessToken));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        dispatch(updateMinuteResponse(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const downloadMinute = (meetingId, token) => {
  return (dispatch) => {
      if (!token) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/downloadMinutes/${meetingId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    axios
      .get(webApiUrl, headerObject)
      .then((result) => {
        const resData = result.data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const getMomAcceptDetails = (meetingId, token) => {
  return (dispatch) => {
      if (!token) {
      console.warn("Access token is missing");
      return;
    }
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/minute/getMomAcceptDetails/${meetingId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    axios
      .get(webApiUrl, headerObject)
      .then((result) => {
        const resData = result.data;
        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }

        dispatch(setMomAcceptDetails(resData));
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        if (handleApiError(err)) return;
        
      });
  };
};

export const setMomAcceptDetails = (data) => {
  return {
    type: SET_MOM_ACCEPT_DETAILS,
    payload: data,
  };
};
